var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Folder",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#cae7f1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-folder-open",
    "data-name": "Icon awesome-folder-open",
    d: "M27.4,15.411,23.931,21.35a3.061,3.061,0,0,1-2.644,1.519H2.154a1.148,1.148,0,0,1-.992-1.727L4.627,15.2a3.061,3.061,0,0,1,2.644-1.519H26.4a1.148,1.148,0,0,1,.992,1.727ZM7.271,12.154h15.69v-2.3a2.3,2.3,0,0,0-2.3-2.3H13.011L9.95,4.5H2.3A2.3,2.3,0,0,0,0,6.8V20.1l3.3-5.665A4.608,4.608,0,0,1,7.271,12.154Z",
    transform: "translate(8.104 5.928)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFolder);
export default __webpack_public_path__ + "static/media/Sidebar-Folder.f440573b0bda72af713c9a7ef6fc34c8.svg";
export { ForwardRef as ReactComponent };